import React from "react";
import CategoryProductList from "./CategoryProductList";

const GlowPlugParts = () => {
  return (
    <CategoryProductList
      categoryName="Glow Plug"
      categorySlug="glow_plug"
    />
  );
};

export default GlowPlugParts;
